// True if `dataSetId` is the golden nominal for `schemaId`.
//
// Combines the backend flag (`isGoldenNominal` on the dataset / search-dedup hit) with any
// in-session nominate/revoke override held in `store.goldenNominal.goldenBySchema`, so the UI
// reflects a nomination/revocation immediately without waiting for a re-fetch:
//   - if the schema has a session override, it wins (a revoke stores `null` for the schema);
//   - otherwise fall back to the flag carried on the record itself.
export function isDatasetGolden(goldenBySchema, schemaId, dataSetId, fallbackFlag) {
    if (goldenBySchema && schemaId != null && Object.prototype.hasOwnProperty.call(goldenBySchema, schemaId)) {
        return goldenBySchema[schemaId] === dataSetId;
    }
    return !!fallbackFlag;
}
